/* TITANOR advertorial helper */
(function(){
  function init(){
    if(document.querySelector('.txa-sticky')){document.body.classList.add('txa-has-sticky');}
    else{document.body.classList.remove('txa-has-sticky');}
  }
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',init);
})();
